import { Capacitor } from '@capacitor/core';
import { isAndroidCapacitor } from './platform';

/**
 * Waits for Capacitor to be ready before resolving
 * This is crucial for ensuring native APIs are available
 */
export const waitForCapacitor = async (): Promise<void> => {
  if (!isAndroidCapacitor()) {
    return;
  }
  
  // Check if we're in a Capacitor environment
  if (window.Capacitor) {
    // Wait a small amount of time to ensure native bridge is ready
    // This is a workaround for timing issues with Capacitor initialization
    await new Promise(resolve => setTimeout(resolve, 100));
  }
};